import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { base_host, environment, my_port, my_protocol } from 'src/environments/environment';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.css']
})
export class AdminUsersComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  feedbackID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  company = [];
  users = [];
  pathUrl;
  order;
  isAverageCert = false;
  isNPSCert = false;
  subGroups = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {}

  ngOnInit(): void {
    this.fetchUsers();
  }

  fetchUsers() {
    this.http.get(environment.ADMIN_USERS, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.users = res.message;
          console.log(this.users);

        }
        else {
          console.log('Failed to fetch users')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }



}
